/* --------------------------------------------------------------------------------------
   matterSearchPopup.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const matterSearchPopupComponent = {
  template: require("./matterSearchPopup.html"),
  bindings: {
    display: "=",
    selected: "=",
    onNodeSwitch: "&",
    onClose: "&",
  },
  controllerAs: "vm",
  controller: class matterSearchPopupCtrl {
    /*@ngInject*/
    constructor(browserService, commonService, $timeout, $state) {
      this.browserService = browserService;
      this.commonService = commonService;
      this.$timeout = $timeout;
      this.$state = $state;
    }

    async $onInit() {
      this.screenSize = await this.commonService.getScreenSize();
      this.matterSearchTerms = "";
      this.searching = false;
      this.searchFinished = false;
      this.selected = [];
      this.matterSearchResults = [];
      angular.element("#matter-search-message-table-wrapper").height("1250px");
    }

    async matterSearch() {
      if (this.matterSearchTerms.trim().length < 3) {
        angular.element("#empty-search-term-banner").xrxbanner("call");
        return;
      }

      this.searching = true;
      this.getKeyboard().accept();

      try {
        const response = await this.browserService.getNode(
          this.browserService.selectedClientId,
          this.browserService.selectedClientDisplayName,
          "matter",
          this.matterSearchTerms.trim()
        );

        this.matterSearchResults = response.Children;

        this.searching = false;
        this.searchFinished = true;

        this.updateResultsTableScroll();
        this.commonService.updateView();
      } catch (error) {
        this.searching = false;
        this.commonService.updateView();
      }
    }

    updateResultsTableScroll() {
      angular
        .element("#matter-search-result-table-wrapper")
        .xrxscrollable("destroy");
      setTimeout(() => {
        if (this.hasScroll()) {
          angular
            .element("#matter-search-result-table-wrapper")
            .removeClass("no-scroll");
          angular.element("#matter-search-result-table-wrapper").xrxscrollable({
            scroll: true,
            height: this.screenSize === 7 ? 286 : 384,
          });
          angular
            .element("#matter-search-result-table-wrapper .shadow")
            .removeClass("hide");
        } else {
          angular
            .element("#matter-search-result-table-wrapper")
            .addClass("no-scroll");
          angular
            .element("#matter-search-result-table-wrapper")
            .xrxscrollable("destroy");
          angular
            .element("#matter-search-result-table-wrapper .shadow")
            .addClass("hide");
        }
        this.commonService.updateView();
      }, 500);
    }

    hasScroll() {
      return this.screenSize === 7
        ? this.matterSearchResults.length * 69 > 286
        : this.matterSearchResults.length * 63 > 384;
    }

    matterSearchTermChanged() {
      this.matterSearchTermsBackup = angular.copy(
        this.matterSearchTerms.trim()
      );
    }

    matterSearchTermCancel() {
      this.$timeout(
        () => (this.matterSearchTerms = this.matterSearchTermsBackup),
        50
      );
    }

    ok() {
      this.selected = this.matterSearchResults.filter((r) => r.selected);
      this.matterSearchResults = [];
      this.getKeyboard().accept();
      this.closePopup();
    }

    cancel() {
      this.getKeyboard().accept();
      this.closePopup();
    }

    closePopup() {
      this.matterSearchResults = [];
      this.display = false;
      this.onClose();
      this.commonService.updateView();
    }

    getKeyboard() {
      return angular.element("#matter-search-input").getkeyboard();
    }

    getSelected() {
      if (!this.hasOwnProperty("matterSearchResults")) return [];
      return this.matterSearchResults.filter((item) => item.selected);
    }

    getResultsTableHeight() {
      const maxHeight = this.screenSize === 7 ? 286 : 384;
      const rowHeight = this.screenSize === 7 ? 66 : 60;
      const totalHeight = this.matterSearchResults.length * rowHeight;
      return Math.min(maxHeight, totalHeight);
    }

    async select(node) {
      if (node.EntryType != "Document") {
        this.selected = node;
      } else {
        this.updateSelectedNodes(node);
      }
      await this.commonService.updateView();
    }

    updateSelectedNodes(node) {
      if (!this.selected.includes(node)) this.selected.push(node);
      else this.selected = this.selected.filter((n) => n != node);
    }

    async handleMatterSelect(item) {
      await this.select(item);
      this.onNodeSwitch();
      this.display = false;
      this.commonService.updateView();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/components/matterSearchPopup.component.js